import { useEffect, useState } from 'react';
import { API_BASE, USE_PROXY } from '../ton/config';

/**
 * Hash (hex) of the most recent lottery draw transaction — the on-chain tx in
 * which the prize was paid. Served by the backend indexer (`/api/last-win`),
 * since the contract getter exposes the winner's address but no tx hash.
 *
 * Pass `lastLotteryTime` so a new draw re-fetches the fresh hash. Returns null
 * when the backend proxy isn't configured or no draw has happened yet.
 */
export function useLastWinTx(lastLotteryTime: number): string | null {
  const [txHash, setTxHash] = useState<string | null>(null);

  useEffect(() => {
    if (!USE_PROXY || lastLotteryTime <= 0) {
      setTxHash(null);
      return;
    }
    let cancelled = false;
    fetch(`${API_BASE}/api/last-win`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data: { txHash?: string | null } | null) => {
        if (!cancelled) setTxHash(data?.txHash ?? null);
      })
      .catch(() => {
        if (!cancelled) setTxHash(null);
      });
    return () => {
      cancelled = true;
    };
  }, [lastLotteryTime]);

  return txHash;
}
